<template>
  <div class="col-12">
    <div class="col-12 mb-3">
      <p>
        {{ $t('menu.settings.integrations.lineOneDescription') }}
      </p>
      <p>
        {{ $t('menu.settings.integrations.lineTwoDescription') }}
      </p>
      <p>
        {{ $t('menu.settings.integrations.lineThreeDescription') }}
      </p>
    </div>
    <div class="form-group">
      <label for="username"
        >{{ $t('menu.settings.integrations.userNameZenvia') }}:</label
      >
      <input
        id="username"
        type="text"
        class="form-control"
        :placeholder="`${this.$t(
          'menu.settings.integrations.placeholderEnterUserName',
        )}`"
        v-model="zenviaUsername"
      />
      <div class="invalid-feedback">
        {{ $t('menu.settings.integrations.feedbackInformUserName') }}
      </div>
      <label for="password" class="mt-2"
        >{{ $t('menu.settings.integrations.passwordLabel') }}:</label
      >
      <input
        id="password"
        type="password"
        class="form-control"
        :placeholder="`${this.$t(
          'menu.settings.integrations.placeholderEnterPass',
        )}`"
        v-model="zenviaPassword"
      />
      <div class="invalid-feedback">
        {{ $t('menu.settings.integrations.feedbackInformPass') }}
      </div>
      <label for="aggregateId" class="mt-2"
        >{{ $t('menu.settings.integrations.aggregateId') }}:</label
      >
      <input
        id="aggregateIds"
        type="text"
        class="form-control"
        :placeholder="`${this.$t(
          'menu.settings.integrations.placeholderEnterAggregateId',
        )}`"
        v-model="zenviaAggregateId"
      />
      <div class="invalid-feedback">
        {{ $t('menu.settings.integrations.feedbackInformAggregateId') }}
      </div>
    </div>
    <div class="form-group">
      <div class="col-4 dinline">
        <button class="btn btn-primary" v-b-modal.modalTestZenviaConfiguration>
          {{ $t('menu.settings.integrations.integrationTest') }}
        </button>
        <b-modal
          id="modalTestZenviaConfiguration"
          :title="`${this.$t('menu.settings.integrations.titleEnterPhone')}`"
          size="md"
          @ok="testConfig"
        >
          <div>
            <div class="row col-12">
              <label for="username-test"
                >{{ $t('menu.settings.integrations.userNameZenvia') }}:</label
              >
              <input
                id="username-test"
                class="form-control"
                type="text"
                v-model="zenviaUsername"
                :placeholder="`${this.$t(
                  'menu.settings.integrations.placeholderEnterUserTest',
                )}`"
              />
            </div>
            <div class="row col-12">
              <label for="password-test" class="mt-2"
                >{{ $t('menu.settings.integrations.passwordLabel') }}:</label
              >
              <input
                id="password-test"
                class="form-control"
                type="password"
                v-model="testZenviaPassword"
                :placeholder="`${this.$t(
                  'menu.settings.integrations.placeholderEnterPasswordTest',
                )}`"
              />
            </div>
            <div class="row col-12">
              <label for="aggregate-id-test" class="mt-2">
                {{
                  $t('menu.settings.integrations.feedbackInformAggregateId')
                }}:</label
              >
              <input
                id="aggregate-id-test"
                class="form-control"
                type="text"
                v-model="testZenviaAggregateId"
                :placeholder="`${this.$t(
                  'menu.settings.integrations.placeholderAggregateIdTest',
                )}`"
              />
            </div>
            <div class="row col-12">
              <label for="celphone-test" class="mt-2"
                >{{ $t('menu.settings.integrations.phone') }}:</label
              >
              <input
                id="celphone-test"
                class="form-control"
                type="text"
                v-model="testCellNum"
                :placeholder="`${this.$t('menu.settings.integrations.phone')}`"
              />
            </div>
          </div>
        </b-modal>
      </div>
      <div class="custom-switch col-4">
        <input
          type="checkbox"
          class="custom-control-input"
          id="enable-config"
          :title="`${this.$t('menu.settings.integrations.titleStatus')}`"
          v-model="zenviaEnable"
        />
        <label class="custom-control-label" for="enable-config">
          {{ $t('menu.settings.integrations.integrationHabilit') }}
        </label>
      </div>
    </div>
    <div class="form-group pull-right">
      <button
        @click="cancelConfig"
        class="btn btn-secondary"
        style="max-width: 300px;"
      >
        {{ $t('menu.settings.integrations.cancel') }}
      </button>
      <button
        @click="saveConfig"
        class="btn btn-primary"
        style="max-width: 300px;"
      >
        {{ $t('menu.settings.integrations.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import swal from 'sweetalert';

export default {
  name: 'zenvia',

  data() {
    return {
      zInitialUsername: null,
      zInitialPassword: null,
      zInitialAggregateId: null,
      zInitialEnable: null,
      zenviaUsername: null,
      zenviaPassword: null,
      zenviaAggregateId: null,
      zenviaEnable: false,
      testCellNum: null,
      testZenviaAggregateId: null,
      testZenviaPassword: null,
      userAuth: null,
      myConfig: {},
    };
  },

  components: {},

  computed: {
    ...mapState('zenvia', ['zenviaConfig']),
  },

  methods: {
    ...mapActions('zenvia', [
      'getZenviaConfig',
      'saveZenviaConfig',
      'testZenviaConfig',
    ]),

    async saveConfig() {
      await this.saveZenviaConfig({
        token: JSON.parse(localStorage.getItem('_indecx')).token,
        companyId: JSON.parse(localStorage.getItem('_indecx')).companyId,
        username: this.zenviaUsername,
        password: this.zenviaPassword,
        aggregateId: this.zenviaAggregateId,
        enabled: this.zenviaEnable,
      });

      this.zInitialUsername = this.zenviaUsername;
      this.zInitialPassword = this.zenviaPassword;
      this.zInitialAggregateId = this.zenviaAggregateId;
      this.zInitialEnable = this.zenviaEnable;

      await swal({
        title: this.$t(
          'menu.settings.integrations.messages.settingsSaved.title',
        ),
        text: this.$t(
          'menu.settings.integrations.messages.settingsSaved.description',
        ),
        icon: 'success',
        buttons: 'Ok',
      });
    },

    async testConfig() {
      try {
        await this.testZenviaConfig({
          token: JSON.parse(localStorage.getItem('_indecx')).token,
          phone: this.testCellNum,
          username: this.zenviaUsername,
          password: this.testZenviaPassword,
          aggregateId: this.testZenviaAggregateId,
        });

        swal({
          title: this.$t(
            'menu.settings.integrations.messages.successSendSMS.title',
          ),
          text: this.$t(
            'menu.settings.integrations.messages.successSendSMS.description',
          ),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$t(
            'menu.settings.integrations.messages.errorSettings.title',
          ),
          text: this.$t(
            'menu.settings.integrations.messages.errorSettings.description',
          ),
          icon: 'error',
        });
      }
    },

    cancelConfig() {
      this.zenviaUsername = this.zInitialUsername;
      this.zenviaPassword = this.zInitialPassword;
      this.zenviaAggregateId = this.zInitialAggregateId;
      this.zenviaEnable = this.zInitialEnable;
      this.$router.push('/integrations');
    },
  },

  async created() {
    this.myConfig = await this.getZenviaConfig({
      token: JSON.parse(localStorage.getItem('_indecx')).token,
      companyId: JSON.parse(localStorage.getItem('_indecx')).companyId,
    });

    this.zenviaUsername = this.myConfig.username;
    this.zenviaPassword = this.myConfig.password;
    this.zenviaAggregateId = this.myConfig.aggregateId;
    this.zenviaEnable = this.myConfig.enabled;
    this.zInitialUsername = this.myConfig.username;
    this.zInitialPassword = this.myConfig.password;
    this.zInitialAggregateId = this.myConfig.aggregateId;
    this.zInitialEnable = this.myConfig.enabled;
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0px;
}
.p-l-10 {
  padding-left: 10px;
}
.custom-switch {
  display: inline;
}
.dinline {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/zenvia/index.vue